export default {
  name: 'Internal Failure',
  description: 'Checking Outputs from Processing Steps and Reworking Failures That Don’t Escape to Customers',
  completed: false,
  color: '#FEB019',
  banner: 'parallax-purple.jpg',
  costs: [
    {
      name: 'Rework',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Scrap',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Checking Outputs',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
  ]
};